import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/collect/hadeTitle@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-f66d6a36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PaySign" }
const _hoisted_2 = { class: "classTitle" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "logo-img"
}
const _hoisted_4 = {
  key: 1,
  class: "success flexBox h-center"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mt-200" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-bar" }, null, -1))
const _hoisted_8 = { class: "contentBox" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "班型名称：", -1))
const _hoisted_13 = { class: "labelText" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "姓名：", -1))
const _hoisted_16 = { class: "labelText" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "手机号：", -1))
const _hoisted_19 = { class: "labelText" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "订单编号：", -1))
const _hoisted_22 = { class: "labelText" }
const _hoisted_23 = {
  key: 0,
  class: "item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "支付方式：", -1))
const _hoisted_25 = { class: "labelText" }
const _hoisted_26 = {
  key: 1,
  class: "item"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "交易单号：", -1))
const _hoisted_28 = { class: "labelText" }
const _hoisted_29 = {
  key: 2,
  class: "item"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "支付时间：", -1))
const _hoisted_31 = { class: "labelText" }
const _hoisted_32 = {
  key: 3,
  class: "item"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "应付金额：", -1))
const _hoisted_34 = { class: "labelText" }
const _hoisted_35 = {
  key: 4,
  class: "price flexBox h-center"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode("应付金额：")
const _hoisted_37 = {
  key: 5,
  class: "price flexBox h-center"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode("首付金额：")
const _hoisted_39 = {
  key: 6,
  class: "stages-tip"
}
const _hoisted_40 = {
  key: 0,
  class: "tip"
}
const _hoisted_41 = { class: "btn-groups" }
const _hoisted_42 = ["href"]
const _hoisted_43 = ["href"]
const _hoisted_44 = ["href"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("div", null, "哈德（厦门）教育集团有限公司"),
  /*#__PURE__*/_createElementVNode("div", null, "客服电话：4008-163-998")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pay = _resolveComponent("Pay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({ headContent: true, pureBg: _ctx.info.detail.payStatus != 1 })
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.info.detail.payStatus == 1)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: require(`@/assets/collect/${_ctx.info.detail.payStatus}.png`),
                  alt: ""
                }, null, 8, _hoisted_5),
                _createElementVNode("div", null, _toDisplayString(_ctx.info.payStatus[_ctx.info.detail.payStatus]), 1)
              ]))
        ])
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_ctx.info.detail.payStatus != 1)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "payStatusTag",
                src: require(`@/assets/collect/${_ctx.info.detail.payStatus}icon.png`),
                alt: ""
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.info.detail.shopName), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.info.detail.studentName), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.info.detail.phone), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.info.detail.orderNumber), 1)
            ]),
            (_ctx.info.detail.isPaid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.info.payType[_ctx.info.detail.payType]), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.info.detail.payStatus != 1 && _ctx.info.detail.tradeNo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.info.detail.tradeNo), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.info.detail.isPaid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.info.detail.paidTime), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.info.detail.firstPayPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.info.detail.orderPrice / 100) + "元", 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.info.detail.firstPayPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("span", null, _toDisplayString(_ctx.info.detail.orderPrice / 100) + "元", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.info.detail.firstPayPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("span", null, _toDisplayString(_ctx.info.detail.firstPayPrice / 100) + "元", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.info.detail.firstPayPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.info.detail.remark), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.info.detail.isPaid && (_ctx.info.detail.previewUrl || (_ctx.info.detail.commonContractUrl && _ctx.info.detail.commonContractStatus === 1) || (_ctx.info.detail.supplementContractUrl && _ctx.info.detail.supplementContractStatus === 1)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, "为保证您的权益，请尽快完成电子协议签约。"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_41, [
        (!_ctx.info.detail.isPaid && _ctx.info.detail.payStatus != 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "btn payButton",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPay && _ctx.showPay(...args)))
            }, "立即支付"))
          : _createCommentVNode("", true),
        (_ctx.info.detail.payStatus == 1 && _ctx.info.detail.previewUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "btn previewButton",
              href: _ctx.info.detail.previewUrl,
              target: "_blank"
            }, "预览协议", 8, _hoisted_42))
          : _createCommentVNode("", true),
        (_ctx.info.detail.isPaid && _ctx.info.detail.commonContractUrl && _ctx.info.detail.commonContractStatus === 1)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "btn payButton",
              target: "_blank",
              href: _ctx.info.detail.commonContractUrl
            }, _toDisplayString(_ctx.info.detail.supplementContractUrl ? "签署通用协议":"立即签署协议"), 9, _hoisted_43))
          : _createCommentVNode("", true),
        (_ctx.info.detail.isPaid && _ctx.info.detail.supplementContractUrl && _ctx.info.detail.supplementContractStatus === 1)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "btn supplyButton",
              target: "_blank",
              href: _ctx.info.detail.supplementContractUrl
            }, " 签署保障协议 ", 8, _hoisted_44))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_45,
    _createVNode(_component_Pay, {
      orderNumber: _ctx.info.orderNumber,
      returnUrl: _ctx.info.returnUrl,
      params: {channelTypeId:_ctx.info.detail.channelTypeId}
    }, null, 8, ["orderNumber", "returnUrl", "params"])
  ], 64))
}